import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

// Define an interface for the field configuration
export interface ModalField {
  controlName: string;
  label: string;
  type: 'text' | 'email' | 'tel' | 'number' | 'password' | 'select';
  placeholder?: string;
  required?: boolean;
  options?: { id: any; label: string }[];
}

@Component({
  selector: 'app-modal',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css'],
})
export class ModalComponent implements OnInit {
  @Input() modalId: string = 'default-modal-id'; // Unique ID for the modal
  @Input() title: string = 'Default Modal Title';
  @Input() fields: ModalField[] = []; // Array to define form fields

  @Output() formSubmit = new EventEmitter<any>();

  modalForm!: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm(): void {
    const group: { [key: string]: any } = {};
    this.fields.forEach((field) => {
      const validators = field.required ? [Validators.required] : [];
      // Add more validators based on type if needed (e.g., Validators.email)
      if (field.type === 'email' && field.required) {
        validators.push(Validators.email);
      } else if (field.type === 'email') {
        // Optional email validator if needed, requires custom logic or library
        // For simplicity, only adding email validator if required for now
      }
      group[field.controlName] = ['', validators];
    });
    this.modalForm = this.fb.group(group);
  }

  onSubmit(): void {
    if (this.modalForm.valid) {
      this.formSubmit.emit(this.modalForm.value);
      // Optionally close the modal programmatically here if needed
      // Or rely on the data-modal-hide attribute on the submit button/close button
      // Example: document.querySelector(`[data-modal-toggle='${this.modalId}']`)?.click(); // Simulate toggle to close
    } else {
      // Mark fields as touched to show validation errors
      this.modalForm.markAllAsTouched();
    }
  }

  // Optional: Method to reset form when modal closes (might need event listener or parent call)
  resetForm(): void {
    this.modalForm.reset();
  }
}
